module.exports = __webpack_public_path__ + "images/stickers/star.5a16f73177f560c7be17.png";